










import Vue from 'vue';
import Component from 'vue-class-component';
import * as types from '@/store/types';
import { Prop } from 'vue-property-decorator';
import { INote} from '@/entities/note/note.interface';
import { NoteType } from '@/entities/note/note.type';

@Component({})
export default class NoteComponent extends Vue {
    @Prop() public note: INote;

    public successType: NoteType = NoteType.Success;
    public failType: NoteType = NoteType.Error;

    public close(guid: string) {
        this.$store.commit(types.REMOVE_NOTE, guid);
    }
}
